import React from "react";
import { Typography, Grid } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import { UploadButtons } from "./components/atoms/UploadButtons";
import { UploadFilesList } from "./components/atoms/UploadFilesList";
import { UploadProgress } from "./components/atoms/UploadProgress";
import { observer } from "mobx-react-lite";
import { UploadType } from "../../static/enums/UploadType";
import { uploadFilesService } from "../../services/UploadFilesService";
import { getCachedUploadFilesUi } from "../../mobx/ui/UploadFilesUi";
import { snackbarStore } from "../../mobx/ui/SnackbarStore";

export interface UploadFilesProps {
	type: UploadType;
	title: string;
	multiple?: boolean;
}

export interface UploadFilesForm {
	files: FileList;
}

export default observer(function UploadFiles({ type, title, multiple = false }: UploadFilesProps) {
	const { setLoadProcess, setIsLoading } = getCachedUploadFilesUi(type);
	const methods = useForm<UploadFilesForm>({
		defaultValues: {
			files: undefined,
		},
	});
	const { handleSubmit, watch } = methods;
	watch("files");

	const upload = async (data: UploadFilesForm) => {
		setIsLoading(true);
		const { files } = data;
		try {
			await uploadFilesService.importFiles({ type, files }, (progressEvent) => {
				setLoadProcess(Math.round((100 * progressEvent.loaded) / progressEvent.total));
			});
		} catch (e) {
			snackbarStore.notifyError("Произошла ошибка загрузки! Проверьте переданные файлы");
		} finally {
			setLoadProcess(0);
			setIsLoading(false);
		}
	};

	return (
		<FormProvider {...methods}>
			<Grid container item flexDirection={"column"} sx={{ marginBottom: "30px" }}>
				<Grid
					container
					flexDirection={"column"}
					item
					xs={2}
					sx={{ minWidth: "350px" }}
					component={"form"}
					onSubmit={handleSubmit(upload)}
				>
					<Typography variant={"subtitle2"} gutterBottom>
						{title}
					</Typography>
					<UploadButtons multiple={multiple} />
					<UploadFilesList />
					<UploadProgress type={type} />
				</Grid>
			</Grid>
		</FormProvider>
	);
});
